import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/rn3";
import { useT } from "@/lib/i18n";
import { BookOpen, Calculator, Receipt, FileSignature, Globe2, MessagesSquare, Sparkles, ArrowRight } from "lucide-react";

const OPTION_KEYS = [
  { key: "bookkeeping", icon: BookOpen },
  { key: "tax_prep", icon: Calculator },
  { key: "notary", icon: FileSignature },
  { key: "itin", icon: FileSignature },
  { key: "sales_tax", icon: Receipt },
  { key: "translation", icon: Globe2 },
  { key: "consultation", icon: MessagesSquare },
];

const Welcome = () => {
  const t = useT();
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex flex-col">
      <div className="rn3-container py-10 flex justify-center">
        <img src={LOGO_URL} alt="Roman Numerals III" className="w-24 h-24 object-contain" />
      </div>
      <div className="rn3-container flex-1 pb-16">
        <div className="max-w-xl mx-auto text-center">
          <div className="rn3-eyebrow flex items-center justify-center gap-2"><Sparkles className="w-4 h-4" /> {t("welcome.eyebrow")}</div>
          <h1 className="font-serif-display text-4xl sm:text-5xl mt-3 leading-tight">
            {t("welcome.h2_a")}<br />
            <span className="italic text-[#8B1C22]">{t("welcome.h2_b")}</span>
          </h1>
          <div className="border-t border-[#C4A252] w-12 mx-auto my-6" />
        </div>

        <div className="max-w-xl mx-auto mt-6 space-y-3" data-testid="welcome-options">
          {OPTION_KEYS.map((o) => (
            <Link
              key={o.key}
              to={o.key === "consultation" ? "/appointments?service=consultation" : `/intake?service=${o.key}`}
              data-testid={`welcome-opt-${o.key}`}
              className="flex items-center justify-between bg-white border border-[#E5E5E5] hover:border-[#C4A252] p-5 transition-colors group"
            >
              <div className="flex items-center gap-4">
                <o.icon className="w-6 h-6 text-[#8B1C22]" />
                <span className="text-base font-medium text-[#0A0A0A]">{t(`welcome.opt.${o.key}`)}</span>
              </div>
              <ArrowRight className="w-5 h-5 text-[#C4A252] group-hover:translate-x-1 transition-transform" />
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/" className="text-xs uppercase tracking-widest text-[#737373] hover:text-[#8B1C22]" data-testid="welcome-back-home">← {t("welcome.back_home")}</Link>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
